import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { VerticalOneColumnLayout } from '../../atoms/VerticalOneColumnLayout';
import { stretchColumn } from '../../theme/helpers/stretchColumn';

export const $DatatableLayout = styled(VerticalOneColumnLayout)<{
  $hasScrollBody: boolean;
}>`
  ${({ $hasScrollBody }) => ($hasScrollBody ? stretchColumn : null)};
`;

export const $PaginationContainer = styled.div`
  overflow: visible;
  padding-left: ${spacing('sm')};
  padding-right: ${spacing('sm')};

  && > div {
    margin-top: 0;
  }
`;
